export class Carte {
    id: number | null = 0;
    codeClient: string | null = null;
    numero: string | null = null;
    type: string | null = null;
    description: string | null = null;

    idArticle: number | null = null;
    designationArticle?: string | null = null;

    idBranche: number | null = null;
    nomBranche?: string | null = null;

    statut: string | null = null;
    rfidCode: string | null = null;
    codeQr: string | null = null;
    codePin: string | null = null;

    dateValidite: Date | null = null;
    dateExtremeValidite: Date | null = null;

    limiteMensuelEs: number | null = null;
    limiteMensuelGo: number | null = null;
    limitePrise: number | null = null;

    solde?: number | null = null;

    noLimitUpToMonthLimit: boolean | null = null;

    accessFailedCount: number | null = null;
    lockoutEnd: Date | null = null;
    isLockedPermanently: boolean | null = null;

    // #region audit

    operation?: string | null = null;
    modifiedDate?: Date | null = null;

    // #endregion

    // #region allocation

    nomClient?: string | null = null;

    allocationQte?: number | null = null;
    allocationValeur?: number | null = null;

    // #endregion

    constructor(numero?: string) {
        this.numero = numero ?? null;
    }
}
